import { NEWS_ROUTE } from "_constants";
import { lazy } from "react";

const News = lazy(() => import("pages/news"));

export const newsRoutes = [{ path: NEWS_ROUTE, element: <News /> }];
